import type { AddNoteRequest } from '@contracts/note/AddNoteRequest';
import type { PermitSummary } from '@src/orders/domain/PermitSummary';
import { OrdersNavigation } from '@src/routing/OrdersNavigation';
import { useLocation, useNavigate } from 'react-router-dom';

export interface ReplacePermitTypeNavigationState {
  note?: AddNoteRequest;
  jurisdiction: string;
  permitType: string;
}

export const useReplacePermitTypeNavigationState = () => {
  const location = useLocation();
  const preservedEditValues = location.state as
    | ReplacePermitTypeNavigationState
    | undefined;
  const note: AddNoteRequest | undefined = preservedEditValues?.note;

  return { note };
};

export const useNavigateToReplacePermitType = () => {
  const navigate = useNavigate();

  const navigateToReplacePermitType = ({
    note,
    permit,
    orderId,
  }: {
    note?: AddNoteRequest;
    permit: PermitSummary;
    orderId: string;
  }) => {
    const state: ReplacePermitTypeNavigationState = {
      note,
      jurisdiction: permit.jurisdiction,
      permitType: permit.type,
    };
    navigate(OrdersNavigation.replacePermitType.url(orderId, permit.id), {
      state,
    });
  };

  return { navigateToReplacePermitType };
};
